import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AOS from 'aos';
import 'aos/dist/aos.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Header from "./content/Header";
import Home from "./content/components/Home";
import Request from "./content/components/Request";
import About from "./content/components/About";
import Testimonial from "./content/components/Testimonial";
import PrivacyPolicy from "./content/components/PrivacyPolicy";
import Footer from "./content/Footer";

const MainPage = () => {
	return (
		<>
			<Home/>
			<About/>
			<Request/>
			<Testimonial/>
		</>
	);
};

const App = () => {

	const location = useLocation();

	useEffect(() => {
		requestAnimationFrame(() => {
		  	window.scrollTo(0, 0);
			const timer = setTimeout(() => {
				AOS.init({
					duration: 900,
					easing: 'ease-in-out',
					once: true,
					mirror: false,
					anchorPlacement: 'top-bottom',
					disable: false
				});
		
				AOS.refresh();
			}, 100);
		  	return () => clearTimeout(timer);
		});
	}, [location.pathname]);

	return (
		<>
			<Header/>
			<Routes>
				<Route path="/" element={<MainPage />} />
				<Route path="/privacy-policy" element={<PrivacyPolicy />} />
			</Routes>
			<Footer/>
			<ToastContainer/>
		</>
	);
};

export default App;